/* global axios */
import ApiClient from './ApiClient';
import { browserTimeParams } from '../helper/timezoneOffset';

class CustomViewsAPI extends ApiClient {
  constructor() {
    super('custom_filters', { accountScoped: true });
  }

  getCustomViewsByFilterType(type) {
    return axios.get(`${this.url}?filter_type=${type}`, {
      params: browserTimeParams(),
    });
  }

  getManageable(type) {
    return axios.get(`${this.url}/manageable`, {
      params: { filter_type: type },
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`, {
      params: browserTimeParams(),
    });
  }

  create(data) {
    return axios.post(this.url, data, {
      params: browserTimeParams(),
    });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data, {
      params: browserTimeParams(),
    });
  }

  deleteCustomViews(id, type) {
    return axios.delete(`${this.url}/${id}?filter_type=${type}`);
  }
}

export default new CustomViewsAPI();
